// Displays a reports page with various report options
import React from 'react';
import axios from 'axios';
import { pdf } from '@react-pdf/renderer';
import { useState, useRef, useEffect } from 'react';
import { serverURL } from '../helpers/dataServerURL';
import styles from '../css/reports.module.css';
import PDFFile from '../components/PDFFile';
import ReportsHero from '../components/ReportsHero';
import ActivityRpt from '../components/ActivityRpt';
import ActivityByHrRpt from '../components/ActivityByHrRpt';
import StayDurationRpt from '../components/StayDurationRpt';
import InTicketsReport from '../components/InTicketsReport';
import ClosedTicketsReport from '../components/OutTicketsReport';
import { convertToDatabaseDateTime } from '../helpers/timeDifference';
import { Slide, toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { insertUnCheckedInTickets } from '../helpers/databaseAPI';

let newArray = [];

export default function Reports() {
  const logInURL = serverURL.server.url;
  const [reportData, setReportData] = useState([]);
  const dateRangeTotalInTicketsRef = useRef([]);
  const [dateRangeTotalInTickets, setDateRangeTotalInTickets] = useState('');
  const dateRangeTotalClosedTicketsRef = useRef([]);
  const [dateRangeTotalClosedTickets, setDateRangeTotalClosedTickets] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [pdfURL, setPdfURL] = useState(null);

  const reportDataRef = useRef([]);

  const reportsTypeOptions = useRef(0);

  const generatePdfURL = async () => {
    const blob = await pdf(
      <PDFFile reportData={reportData} pdfURL={() => pdfURL} startDate={startDate} endDate={endDate} />,
    ).toBlob();
    console.log('Generated PDF blob:', blob);
    return URL.createObjectURL(blob);
  };

  useEffect(() => {
    generatePdfURL().then((url) => {
      setPdfURL(url);
      console.log('PDF URL generated:', url);
    });
    console.log('PDF URL generated:', pdfURL);
  }, []);

  async function fetchReportData() {
    try {
      const response = await axios.get(`${logInURL}/reports/activityReports/${startDate}&${endDate}`);

      newArray = response.data.map((item) => ({
        Ticket: item.Ticket,
        SectionName: item.SectionName,
        LaneNum: item.LaneNum,
        SpaceNum: item.SpaceNum,
        DateTimeIn: item.DateTimeIn,
        DateTimeOut: item.DateTimeOut,
        CarMake: item.CarMake,
        CarColor: item.CarColor,
        LicensePlate: item.LicensePlate,
      }));
      setReportData(newArray);
      reportDataRef.current = newArray;
    } catch (error) {
      console.error('Error fetching report data:', error);
    }
  }

  // Fetch activity report data for a given date range grouped by hour
  async function fetchActivityByHours() {
    try {
      const response = await axios.get(`${logInURL}/reports/activitiesCountByHour/${startDate}&${endDate}`);
      if (response.data) {
        setReportData(response.data);
        reportDataRef.current = response.data;
      } else {
        console.log('No data found for the given date range');
      }
    } catch (error) {
      console.error('Error fetching activity by hours:', error);
    }
  }

  async function fetchStayDurationReport() {
    try {
      const response = await axios.get(`${logInURL}/reports/stayDurationStats/${startDate}&${endDate}`);
      if (response.data) {
        setReportData(response.data);
        reportDataRef.current = response.data;
      }
    } catch (error) {
      console.error('Error fetching stay duration report data:', error);
    }
  }

  // Function to pull open tickets data
  async function fetchOpenTickets(start, end) {
    try {
      const response = await axios.get(`${logInURL}/reports/openTicketsReport/${startDate}&${endDate}`);
      if (response.data) {
        setReportData(response.data);
        reportDataRef.current = response.data;
      }
    } catch (error) {
      console.error('Error fetching open tickets data:', error);
    }
  }

  // Function to pull closed tickets data
  async function fetchClosedTickets(start, end) {
    try {
      const response = await axios.get(`${logInURL}/reports/closedTicketsReport/${start}&${end}`);
      if (response.data) {
        setReportData(response.data);
        reportDataRef.current = response.data;
      }
    } catch (error) {
      console.error('Error fetching closed tickets data:', error);
    }
  }

  // Make API call to fetch in tickets data
  async function fetchInTicketsData(startDate, endDate) {
    // Implementation for fetching data goes here
    try {
      const response = await axios.get(`${logInURL}/reports/inTicketsReport/${startDate}&${endDate}`);
      console.log('In Tickets Response:', response);
      if (response.data && response.data.length > 0) {
        // Process and set the fetched data
        const inTicketsData = response.data.map((item) => ({
          inTickets: item.inTickets,
          DateIn: item.DateIn,
          HourIn: item.HourIn,
        }));
        setReportData(inTicketsData);
        reportDataRef.current = inTicketsData;
        console.log('In Tickets Data:', inTicketsData, reportDataRef.current);
      }
    } catch (error) {
      console.error('Error fetching in tickets data:', error);
    }
  }

  //Report that shows the total tickets issued grouped by date
  async function fetchTotalInTicketsByDate(start, end) {
    console.log('Fetching total in tickets by date from', start, end);
    try {
      const response = await axios.get(`${logInURL}/reports/totalInTicketsByDate/${start}&${end}`);
      if (response.data) {
        // setReportData(response.data);
        setDateRangeTotalInTickets(Number(response.data[0].ticketsIssued));
        dateRangeTotalInTicketsRef.current = Number(response.data[0].ticketsIssued);
      }
    } catch (error) {
      console.error('Error fetching total in tickets by date:', error);
    }
  }

  // Report that fetches closed tickets data for a given date range
  async function fetchClosedTicketsData(start, end) {
    try {
      const response = await axios.get(`${logInURL}/reports/closedTicketsReportByDate/${start}&${end}`);
      if (response.data) {
        setReportData(response.data);
        reportDataRef.current = response.data;
      }
    } catch (error) {
      console.error('Error fetching closed tickets data:', error);
    }
  }

  // Report that shows the total closed tickets grouped by date
  async function fetchTotalClosedTicketsByDate(start, end) {
    console.log('Fetching total closed tickets by date from', start, end);
    try {
      const response = await axios.get(`${logInURL}/reports/totalClosedTicketsByDate/${start}&${end}`);
      if (response.data) {
        // setReportData(response.data);
        setDateRangeTotalClosedTickets(Number(response.data[0].closedTickets));
        dateRangeTotalClosedTicketsRef.current = Number(response.data[0].closedTickets);
      }
    } catch (error) {
      console.error('Error fetching total closed tickets by date:', error);
    }
  }

  // Determine which report to run based on user selection
  const runReport = () => {
    if (reportsTypeOptions.current === 0) {
      toast.error('Please select a report type checkbox before running reports.');
      return;
    }
    if (startDate === '' || endDate === '') {
      toast.error('Please select a valid start and end date before running reports.');
      return;
    }
    if (new Date(startDate) > new Date(endDate)) {
      toast.error('Start date must be before end date.');
      return;
    }
    if (
      reportsTypeOptions.current === 1 // Activity Report
    ) {
      setReportData([]);
      fetchReportData();
    }
    if (
      reportsTypeOptions.current === 2 // Stay Duration Report
    ) {
      setReportData([]);
      fetchStayDurationReport();
    }
    if (
      reportsTypeOptions.current === 4 // Activity by Hours Report
    ) {
      setReportData([]);
      fetchActivityByHours();
    }
    if (reportsTypeOptions.current === 5) {
      // Open Tickets Report
      setReportData([]);
      fetchOpenTickets();
    }
    if (reportsTypeOptions.current === 6) {
      // Closed Tickets Report
      setReportData([]);
      fetchClosedTickets(startDate, endDate);
    }
    if (reportsTypeOptions.current === 7) {
      // Tickets Issued Report
      setReportData([]);
      fetchInTicketsData(startDate, endDate);
      fetchTotalInTicketsByDate(startDate, endDate);
    }
    if (reportsTypeOptions.current === 8) {
      // Tickets Issued Report
      setReportData([]);
      fetchClosedTicketsData(startDate, endDate);
      fetchTotalClosedTicketsByDate(startDate, endDate);
    }
  };

  return (
    <div className={styles.reportContainer}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        transition={Slide}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={true}
        rtl={true}
        draggable={true}
        pauseOnHover={true}
      />

      <ReportsHero
        activityRpt={
          () => (reportsTypeOptions.current = 1) //Activity Report
        }
        stayRpt={
          () => (reportsTypeOptions.current = 2) //Stay Report
        }
        waitTimeRpt={
          () => (reportsTypeOptions.current = 3) //Wait Time Report
        }
        activityByHoursRpt={
          () => (reportsTypeOptions.current = 4) //Activity by Hours Report
        }
        openTicketsData={
          () => (reportsTypeOptions.current = 5) //Open Tickets Report
        }
        closedTicketsData={
          () => (reportsTypeOptions.current = 6) //Closed Tickets Report
        }
        inTrafficData={
          () => (reportsTypeOptions.current = 7) //Tickets Issued Report
        }
        outTrafficData={
          () => (reportsTypeOptions.current = 8) //Out Traffic Report
        }
        data={() => setReportData([])}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        runReport={runReport}
        reportsOptions={reportsTypeOptions}
      />

      <div className={styles.reportTable}>
        {reportData.length > 0 &&
          (reportsTypeOptions.current === 1 || 0 ? ( //0 is for search results display
            <div style={reportsTypeOptions.current === 1 ? { display: 'block' } : { display: 'none' }}>
              <ActivityRpt reportData={reportData} />
            </div>
          ) : reportsTypeOptions.current === 4 ? (
            <div style={reportsTypeOptions.current === 4 ? { display: 'block' } : { display: 'none' }}>
              <ActivityByHrRpt reportData={reportData} />
            </div>
          ) : reportsTypeOptions.current === 2 ? (
            <div style={reportsTypeOptions.current === 2 ? { display: 'block' } : { display: 'none' }}>
              <StayDurationRpt reportData={reportData} />
            </div>
          ) : reportsTypeOptions.current === 5 ? (
            <div style={reportsTypeOptions.current === 5 ? { display: 'block' } : { display: 'none' }}>
              <ActivityRpt reportData={reportData} />)
            </div>
          ) : reportsTypeOptions.current === 6 ? (
            <div style={reportsTypeOptions.current === 6 ? { display: 'block' } : { display: 'none' }}>
              <StayDurationRpt reportData={reportData} />
            </div>
          ) : reportsTypeOptions.current === 7 ? (
            <div style={reportsTypeOptions.current === 7 ? { display: 'block' } : { display: 'none' }}>
              <InTicketsReport
                data={reportData}
                totalInTickets={dateRangeTotalInTickets}
                start={convertToDatabaseDateTime(startDate)}
                end={convertToDatabaseDateTime(endDate)}
              />
            </div>
          ) : reportsTypeOptions.current === 8 ? (
            <div style={reportsTypeOptions.current === 8 ? { display: 'block' } : { display: 'none' }}>
              <ClosedTicketsReport
                data={reportData}
                totalOutTickets={dateRangeTotalClosedTickets}
                start={convertToDatabaseDateTime(startDate)}
                end={convertToDatabaseDateTime(endDate)}
              />
            </div>
          ) : null)}
      </div>
    </div>
  );
}
